@if (Capacitor.getPlatform() === 'ios' && (router.lastSuccessfulNavigation?.finalUrl?.root?.children?.['primary']?.segments?.length ?? 0) > 1) {
  <div class="sticky w-full top-0 z-50  bg-white pb-4 px-8"
       style="padding-top: calc(env(safe-area-inset-top) + 0.5rem);">
    <div (click)="location.back()"
         (keyup.enter)="emulateClick($event)"
         class="size-4 flex items-center justify-center "
         tabindex="0">
      <img alt="" class="h-4 w-4 rotate-90" height="60" ngSrc="assets/icons/gray/down.svg" width="60">
    </div>
  </div>
}
<app-header/>
<main>
  <router-outlet/>
</main>
<app-footer/>
